import { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import cx from 'classnames'
import { Typography, Button, FormControlLabel, Radio } from '@material-ui/core'

import { ArrowIcon } from 'icons'
import { useAlertForm } from '../../AlertFormProvider'
import styles from '../../ParameterAlertForm.module.scss'
import stepStyles from './Parameters.module.scss'
import * as SystemUtils from 'utils/system'
import DataTypes from 'constants/DataTypes'

// The user chooses one parameter type.
const Parameters = () => {
  const {
    state: { typeSelected },
    actions,
    meta: { translate, systems }
  } = useAlertForm()
  const { register, errors, setError, clearErrors } = useForm()

  const [indicator, setIndicator] = useState([])
  const [type, setType] = useState([])
  const [selectedTypes, setSelectedTypes] = useState(() =>
    typeSelected.reduce((selected, dataType) => ({ ...selected, [dataType]: true }), {})
  )

  // Find the parameter types available on the project devices.
  useEffect(() => {
    const types = []
    const indicators = []

    systems.forEach(system => {
      SystemUtils.getDataSorted(system).forEach(d => {
        // GO IAQS alerts are not supported.
        if (d.type === DataTypes.GO_IAQS) return

        const isIndicator =
          d.type === DataTypes.THERMAL_INDICATOR ||
          d.type === DataTypes.VENTILATION_INDICATOR ||
          d.type === DataTypes.IAQ ||
          d.type === DataTypes.COVID_19 ||
          d.type === DataTypes.MOLD_INDICATOR

        if (isIndicator) {
          if (!indicators.includes(d.type)) indicators.push(d.type)
        } else {
          // Temperature and humidity have separate high and low alerts.
          if (d.type === DataTypes.TEMPERATURE || d.type === DataTypes.RADIANT_TEMPERATURE) {
            if (!types.includes('tempHigh')) types.push('tempHigh', 'tempLow')
          } else if (d.type === DataTypes.HUMIDITY) {
            if (!types.includes('humHigh')) types.push('humHigh', 'humLow')
          } else if (!types.includes(d.type)) {
            types.push(d.type)
          }
        }
      })
    })

    setIndicator(indicators)
    setType(types)
  }, [systems])

  const handleChangeSelectedTypes = event => {
    clearErrors('types')
    setSelectedTypes({ [event.target.value]: event.target.checked })
  }

  const handleNext = () => {
    const selected = [...indicator, ...type].filter(t => selectedTypes[t])
    if (selected.length === 0) {
      setError('types', { shouldFocus: 'types' })
      return
    }
    actions.completeParameters(selected)
  }

  return (
    <div>
      <div className={styles.nav}>
        <Typography className={styles.subheaderParamsSelected}>
          {translate('addParameterAlertModal.navParams')}
        </Typography>
        <Typography className={styles.subheaderValues}>
          {translate('addParameterAlertModal.navValues')}
        </Typography>
        <Typography className={styles.subheaderDevices}>
          {translate('addParameterAlertModal.navDevices')}
        </Typography>
        <Typography className={styles.subheaderParams}>
          {translate('addParameterAlertModal.navEmails')}
        </Typography>
      </div>

      <div>
        <Typography className={styles.subInfo}>
          {translate('addAlertModal.selectParameters')}
        </Typography>
      </div>

      <Typography className={stepStyles.subTitle}>
        {translate('addAlertModal.indicators')}
      </Typography>
      <div className={stepStyles.checkboxWrapper}>
        {indicator.map((dataType, i) => (
          <div
            key={dataType}
            className={styles.checkboxFormDiv}
          >
            <FormControlLabel
              className={styles.checkboxForm}
              control={
                <Radio
                  className={cx(styles.checkbox)}
                  id={dataType}
                  onChange={handleChangeSelectedTypes}
                  classes={{ checked: styles.checkedBox }}
                  required
                  checked={selectedTypes[dataType] === true}
                  name={`types[${i}]`}
                  value={dataType}
                  inputRef={register()}
                  disableRipple
                />
              }
              label={dataType === 'vocs' ? `${translate(dataType)} (legacy)` : translate(dataType)}
            />
          </div>
        ))}
      </div>

      <Typography className={stepStyles.subTitle}>
        {translate('addAlertModal.parameters')}
      </Typography>
      <div className={stepStyles.checkboxWrapper}>
        {type.map((dataType, i) => (
          <div
            key={dataType}
            className={styles.checkboxFormDiv}
          >
            <FormControlLabel
              className={styles.checkboxForm}
              control={
                <Radio
                  className={cx(styles.checkbox)}
                  id={dataType}
                  onChange={handleChangeSelectedTypes}
                  classes={{ checked: styles.checkedBox }}
                  required
                  checked={selectedTypes[dataType] === true}
                  name={`types[${i}]`}
                  value={dataType}
                  inputRef={register()}
                  disableRipple
                />
              }
              label={dataType === 'vocs' ? `${translate(dataType)} (legacy)` : translate(dataType)}
            />
          </div>
        ))}
      </div>

      <div className={styles.wrapperError}>
        {errors.types && (
          <div className={styles.error}>
            <small>{translate('validation.anyFieldRequired')}</small>
          </div>
        )}
      </div>

      <div
        className={stepStyles.buttonWrapper1}
        style={{ marginTop: type.length + indicator.length < 9 ? '15.5%' : '5%' }}
      >
        <Button
          fullWidth
          disableRipple
          variant='contained'
          className={stepStyles.buttonSiguiente2}
          onClick={handleNext}
        >
          {translate('next')}
          <ArrowIcon className={styles.arrow} />
        </Button>
      </div>
      <div className={styles.buttonWrapper}>
        <Button
          fullWidth
          disableRipple
          variant='contained'
          className={styles.buttonCancelar}
          onClick={actions.hideModal}
        >
          {translate('cancel')}
        </Button>
      </div>
    </div>
  )
}

export default Parameters
